import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';
import { PaletteColor } from '@utils/types';

export const ClearSearchButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 3;
  display: flex;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  align-items: end;
  margin-bottom: 8px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 15px 0 0 20px;
    align-items: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Text = styled.span<{ color: PaletteColor }>`
  color: ${({ theme, color }) => theme.palette[color]};
  padding-left: 5px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding-left: 17px;
  }
  font-size: 14px;
  font-weight: bold;
`;
